import {
    DashboardClaim,
    Guid,
    UserNotificationEventType
} from '@lsq-frontend/remote-services/enterprise/common';
import { PersonDetail } from '@lsq-frontend/remote-services/enterprise/dashboard-services';

export interface INotificationPreferencesGroup {
    groupName: string;
    preferenceControls: INotificationPreferencesUiControl[];
}

export interface INotificationPreferencesUiControl {
    label: string;
    title?: string;
    id: string;
    notificationType: UserNotificationEventType;
    inAppIsOn?: boolean;
    emailIsOn?: boolean;
    // Add IsOn flags for future communication types here.
}

export class NotificationPreferencesState {
    public notificationPreferencesGroups: INotificationPreferencesGroup[];
}

export interface IPermissionsUiControl {
    label: string;
    description: string;
    claims: DashboardClaim[];
    addOnClaims?: DashboardClaim[]; // Additional claims you get by selecting this permission control.
    isOn?: boolean;
    isReadOnly?: boolean;
    hasWarningIcon?: boolean;
    isDisabled?: boolean;
}

export class ManageContactState {
    public companyKey: Guid = null;
    public personKey: Guid = null;
    public personDetail: PersonDetail = null;
    public claims: number[] = null;
    public adminPermissionsUiControls: IPermissionsUiControl[] = null;
    public standardPermissionsUiControls: IPermissionsUiControl[] = null;
}

export interface IClaimRowUiControl {
    label: string;
    description: string;
    viewClaims: DashboardClaim[];
    viewIsOn?: boolean;
    editClaims: DashboardClaim[];
    editIsOn?: boolean;
    hasWarningIcon?: boolean;
    isDisabled?: boolean;
}

export class AdminClaimState {
    public adminSystemClaimManagementUiControl: IPermissionsUiControl = null;
    public adminSystemManagementUiControl: IPermissionsUiControl = null;
    public adminClaimManagementUiControls: IClaimRowUiControl[] = null;
}

export class AddContactState extends ManageContactState {
    public formValue: any = null;
}
